export const SET_IS_LOADING_LEAD_CONVERSATION = 'SET_IS_LOADING_LEAD_CONVERSATION';
export const SET_IS_SUCCESS_LEAD_CONVERSATION = 'SET_IS_SUCCESS_CONVERSATION';
export const SET_IS_ERROR_LEAD_CONVERSATION = 'SET_IS_ERROR_CONVERSATION';
export const GET_LEAD_CONVERSATION = 'GET_LEAD_CONVERSATION';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_lead_conversation.constants.js